module.exports = __webpack_public_path__ + "static/media/people.33705531.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/HomePage/assets/people.svg
// module id = 555
// module chunks = 0